import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  root: {
    width: '100%'
  },
  header: {
    marginBottom: spacing(3)
  }
}))
